import React, { FC, ReactElement, useRef } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Button } from 'antd'
import useEscape from 'hooks/useEscape/useEscape'

import Tooltip from './../Tooltip/Tooltip'

interface IconButtonWithTooltipProps {
    t: string
    icon: ReactElement
    onClick: () => void
}

const IconButtonWithTooltip: FC<IconButtonWithTooltipProps> = ({
    t,
    icon,
    onClick,
}) => {
    const buttonRef = useRef<HTMLInputElement>(null)
    const isMobileView = useMediaQuery({ query: '(max-width: 650px)' })

    useEscape(() => buttonRef.current?.blur())

    return (
        <Tooltip
            placement={isMobileView ? 'bottomLeft' : 'bottom'}
            title={t}
            trigger={['focus', 'hover']}
        >
            <Button type="text" icon={icon} onClick={onClick} ref={buttonRef}>
                <span className="visuallyHidden">{t}</span>
            </Button>
        </Tooltip>
    )
}

export default IconButtonWithTooltip
